/* SI SE NECESITA ALGO MÁS SE PUEDE ESPECIFICAR EN ESTE OPBJETO */
export default { ...JSON.parse(process.env.VUE_APP_CONFIG) };
